<app-dialog-header [title]="'general.api_menu_navigation'"></app-dialog-header>
<mat-dialog-content>
  <div class="flex flex-column flex-flat">
    <ng-container *ngFor="let menu of menuItems">
      <ng-container *ngIf="menu.canAccess() && (menu.route !== 'help')">
        <a class="nav-menu-item nav-header">
          {{ menu.label | translate }}
        </a>
        <ng-container *ngFor="let menuItem of menu.primaryItems">
          <a class="nav-menu-item" [ngClass]="{'active': isActive(menuItem.route, menu)}" *ngIf="menuItem.canAccess()"
             (click)="chooseRoute(menu.route + menuItem.route)">
            {{ menuItem.label | translate }}
          </a>
        </ng-container>
        <ng-container *ngFor="let menuCategory of menu.primaryCategories">
          <ng-container *ngIf="menuCategory.canAccess()">
            <a class="nav-menu-item nav-category" [ngClass]="{'expanded': isExpanded(menuCategory.label)}"
               (click)="toggleCategory(menuCategory.label)">
              {{ menuCategory.label | translate }}
              <mat-icon class="svg-icon" [svgIcon]="'arrow_down'"></mat-icon>
            </a>
            <ng-container *ngIf="isExpanded(menuCategory.label)">
              <ng-container *ngFor="let categoryItem of menuCategory.items">
                <a class="nav-menu-item nav-category-item" [ngClass]="{'active': isActive(categoryItem.route)}" *ngIf="categoryItem.canAccess()"
                   (click)="chooseRoute(menu.route + categoryItem.route)">
                  {{ categoryItem.label | translate }}
                </a>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngFor="let menuItem of menu.items">
          <a class="nav-menu-item" [ngClass]="{'active': isActive(menuItem.route, menu)}" *ngIf="menuItem.canAccess()"
             (click)="chooseRoute(menu.route + menuItem.route)">
            {{ menuItem.label | translate }}
          </a>
        </ng-container>
        <ng-container *ngFor="let menuCategory of menu.categories">
          <ng-container *ngIf="menuCategory.canAccess()">
            <a class="nav-menu-item nav-category" [ngClass]="{'expanded': isExpanded(menuCategory.label)}"
               (click)="toggleCategory(menuCategory.label)">
              {{ menuCategory.label | translate }}
              <mat-icon class="svg-icon" [svgIcon]="'arrow_down'"></mat-icon>
            </a>
            <ng-container *ngIf="isExpanded(menuCategory.label)">
              <ng-container *ngFor="let categoryItem of menuCategory.items">
                <a class="nav-menu-item nav-category-item" [ngClass]="{'active': isActive(categoryItem.route)}" *ngIf="categoryItem.canAccess()"
                   (click)="chooseRoute(menu.route + categoryItem.route)">
                  {{ categoryItem.label | translate }}
                </a>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <div class="nav-footer" (click)="chooseRoute(helpItem.route)">
      <a class="nav-menu-item nav-help" (click)="chooseRoute(helpItem.route)">
        {{ (helpItem.label | translate) | uppercase }}
      </a>
    </div>
  </div>
</mat-dialog-content>
